function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.94 8.05l-3.26-3.16a1 1 0 00-1.4 0l-3.23 3.2a1 1 0 000 1.42 1 1 0 001.42 0L15 8v12.41a10.34 10.34 0 00-3.09-2.79l-2.68-1.54 2-.6a1 1 0 10-.57-1.91l-4.35 1.3a1 1 0 00-.68 1.23l1.21 4.38a1 1 0 001 .73c.09.01.18.01.27 0a1 1 0 00.69-1.24l-.6-2.18 2.73 1.59A8.26 8.26 0 0115 26.46v1.45a1 1 0 002 0V8l1.58 1.53a1 1 0 101.39-1.43l-.03-.05z",
  fill: "#000",
  fillRule: "evenodd"
});

function SvgIcRoutingOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgIcRoutingOptions;